import React from "react";
import { Box, Button, Container, Stack, Typography } from "@mui/material";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";

export default function AccountHeader({ onReload }) {
    return (
        <Box
            sx={{
                borderBottom: "1px solid",
                borderColor: "divider",
                background: "linear-gradient(135deg, rgba(0,0,0,0.04) 0%, rgba(255,165,0,0.18) 100%)",
                py: { xs: 3, md: 4 },
            }}
        >
            <Container maxWidth="lg">
                <Stack
                    direction={{ xs: "column", md: "row" }}
                    spacing={2}
                    alignItems={{ xs: "flex-start", md: "center" }}
                    justifyContent="space-between"
                >
                    <Box>
                        <Typography variant="h4" sx={{ fontWeight: 900, letterSpacing: 0.2 }}>
                            Account &amp; Sicherheit
                        </Typography>
                        <Typography variant="subtitle1" sx={{ mt: 0.5 }}>
                            Vertragsdetails, Kündigung und Passwortverwaltung
                        </Typography>
                    </Box>
                    <Stack direction="row" spacing={1}>
                        <Button variant="outlined" startIcon={<RefreshRoundedIcon />} onClick={onReload}>
                            Aktualisieren
                        </Button>
                    </Stack>
                </Stack>
            </Container>
        </Box>
    );
}
